import { render, staticRenderFns } from "./ComponentApp.vue?vue&type=template&id=1edb9c2c"
import script from "./ComponentApp.vue?vue&type=script&lang=js"
export * from "./ComponentApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports